export function googleCallbackUrl(origin) {
  return `${String(origin).replace(/\/+$/, '')}/`;
}
